export const LOGINID = "toriitorippy"
export const LOGINPW = "testtoriitorippy"